export const stripHtml = html => {
    const tmp = document.implementation.createHTMLDocument('New').body
    tmp.innerHTML = html
    return tmp.textContent || tmp.innerText || ''
}
